import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Collapse,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import formatarData from '../../../util/formatar/formatarData'

const useRowStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  head: {
    backgroundColor: theme.palette.primary.main,
    '& > *': {
      color: theme.palette.common.white,
    }
  },
}));

export default function TabelaCandidatos(props) {
  const classes = useRowStyles();
  const [open, setOpen] = React.useState(false);
  const { vaga } = props;
  const qtdSubs = vaga.subscriptions[0] === null ? 0 : vaga.subscriptions.length

  console.log(vaga);

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {vaga.title}
        </TableCell>
        <TableCell align="right">{qtdSubs}</TableCell>
        <TableCell align="right">{vaga.type}</TableCell>
        <TableCell align="right">{formatarData(vaga.vigency)}</TableCell>
        <TableCell align="right">{vaga.quantity}</TableCell>
      </TableRow>
      {qtdSubs > 0 &&
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  Candidaturas
            </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nome</TableCell>
                      <TableCell>E-mail</TableCell>
                      <TableCell align="right">Data</TableCell>
                      <TableCell align="right">Telefone</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {vaga.subscriptions[0] !== null &&
                      vaga.subscriptions.map((subscriptions) => (
                        <TableRow key={subscriptions.id}>
                          <TableCell component="th" scope="row">
                            {subscriptions.name}
                          </TableCell>
                          <TableCell>{subscriptions.email}</TableCell>
                          <TableCell align="right">{formatarData(subscriptions.register_date)}</TableCell>
                          <TableCell align="right">
                            {subscriptions.contact.cellphone} {(subscriptions.contact.cellphone !== "" && subscriptions.contact.telephone !== "") ? " / " : ""} {subscriptions.contact.telephone}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      }
    </React.Fragment>
  );
}